export const tooltips = {
    'eventstatus':'Number of events from previous ranking week ( Mon-Sun ).',
    'eventsthisweek':'Number of events for the current ranking week ( Mon-Sun).',
    'lastrankingrun':'View the last Ranking run date and time. Admin can Rerun ranking and perform What if? scenarios.',
    'userrequests':'View of consumer requests to access the portal along with their status.',
    'exceptions':'Displays any exceptions found after an upload or ranking is performed.'
}




// WEBPACK FOOTER //
// ./src/utils/tooltip.js